commusoftCommon.service('fullScreenEditorCollection', function() {
    this.setPanelData = function setPanelData(fullObject){
        this.notesCollection = fullObject;
    }
    this.getPanelData = function getPanelData(categoty) {
        return this.notesCollection;
    }
});